// kendo
import { Loader } from "@progress/kendo-react-indicators";

const DrInfraDetailsStatus = ({ loading, status }) => {
  return (
    <div className="dr-infra-details-status-wrapper">
      <div className="dr-infra-details-status-title">Status</div>
      <div>
        {loading ? (
          <Loader
            type="infinite-spinner"
            className="dr-infra-details-status-loader"
          />
        ) : (
          <div className="dr-infra-details-status-text">{status || "NA"}</div>
        )}
      </div>
    </div>
  );
};

export default DrInfraDetailsStatus;
